<template>
  <div>
    <!-- MACHINE INFORATION -->
    <div class="contentWrap" style="padding-bottom: 0;">
      <p class="contentTitle">{{ $t("basicinfo.machineInformation") }}</p>
      <P class="headerP">
        <span>{{ $t("basicinfo.deviceName") }}</span>
        <span>{{ basicinfo.deviceName }}</span>
      </P>
      <P class="headerP">
        <span>{{ $t("basicinfo.serialNumber") }}</span>
        <span>{{ basicinfo.deviceSn }}</span>
      </P>
      <P class="headerP">
        <span>{{ $t("basicinfo.machineModel") }}</span>
        <span>{{ basicinfo.mechBrand }} / {{ basicinfo.mechModel }}</span>
      </P>
      <P class="headerP">
        <span>{{ $t("basicinfo.firmwareVersion") }}</span>
        <!-- <span>{{ basicinfo.deviceName }}</span> -->
        <span>V 191</span>
      </P>
      <!-- <img src="@/assets/images/scissorsCar.png" style="height: 105px;float: right;margin-top: -128px;background: white;position: relative;"><br> -->
    </div>

    <!-- STATUS/MAP -->
    <div style="margin-top:20px;">
      <!-- STATUS -->
      <div class="contentWrap statuWrap">
        <p class="contentTitle">{{ $t("basicinfo.status") }}<span class="timeAgo">{{ timeAgoStatus }}</span></p>
        <P class="statuP">
          <span>{{ $t("basicinfo.batteryModel") }}</span>
          <span>{{ basicinfo.batteryBrand }}&nbsp;{{ basicinfo.batteryModel }}</span>
        </P>
        <P class="statuP">
          <span>{{ $t("basicinfo.batteryCapacity") }}</span>
          <span>{{ basicinfo.batteryCapacity }}</span>
        </P>
        <P class="statuP">
          <span>{{ $t("basicinfo.systemVoltage") }}</span>
          <span>{{ basicinfo.batteryVoltage }}</span>
        </P>
        <P class="statuP">
          <span>{{ $t("basicinfo.SOC") }} </span>
          <span>{{ statuList.soc }}</span>
        </P>
        <P class="statuP">
          <span>{{ $t("basicinfo.current") }}</span>
          <span>{{ statuList.current }}</span>
        </P>
        <P class="statuP">
          <span>{{ $t("basicinfo.voltage") }}</span>
          <span>{{ statuList.voltageRaw }}</span>
        </P>
        <P class="statuP">
          <span>{{ $t("basicinfo.temperature") }}</span>
          <span>{{ statuList.batteryTemperature }}</span>
        </P>
      </div>
      <!-- Map -->
      <div class="contentWrap statuWrap" style="margin: 0 0 0 20px;vertical-align: top;">
        <p class="contentTitle" style="display:inline-block;margin-right:10px;border:none;">{{ $t("basicinfo.map") }}</p>
        <!-- <el-switch v-model="value1" inactive-text="谷歌地图" active-text="高德地图" /> -->
        <div style="height:280px;">
          <!-- 地图------start -->
          <div style="min-height:100px;width: 100%;position:relative;">
            <!-- 高德地图 和 谷歌地图-->
            <el-container style="padding-left: 1px;padding-right: 1px;position: relative;background:white;border-radius: 10px;" class="right"><!--0925 cici-->
              <keep-alive>
                <deviceListMapTem ref="maps" :is-show-g-d-map="value1" :height="height" :location-array="locationList" @fullScreen="fullScreen" />
              </keep-alive>
            </el-container>
            <!-- 悬浮框 -->
            <div class="mapFloatBox">
              <p class="mapFloatBoxTitle">{{ $t("basicinfo.locationInformation") }}</p>
              <p>{{ $t("basicinfo.degreeOfLatitude") }} : {{ location.lat }}</p>
              <p>{{ $t("basicinfo.degreeOfLongitude") }} : {{ location.lon }}</p>
              <p>{{ $t("basicinfo.latestUpdate") }} : {{ location.latestUpdate }}</p>
            </div>
          </div>
          <!-- 地图------end -->
        </div>
      </div>
    </div>

    <!-- STATUSPICTURE -->
    <div class="contentWrap">
      <p class="contentTitle">
        {{ $t("basicinfo.realtimeInformation") }}
        <span class="timeAgo">{{ timeAgo }}</span>
        <el-button v-show="viewTable" type="primary" style="vertical-align: top;margin-top: 7px;float: right;margin-left: 10px;" @click="viewTable=!viewTable;editTable=!editTable">编辑</el-button>
        <el-button v-show="editTable" type="primary" style="vertical-align: top;margin-top: 7px;float: right;" @click="editTable=false;viewTable=true">取消</el-button>
        <el-button type="primary" style="vertical-align: top;margin-top: 7px;float: right;" @click="clickSet">配置</el-button>
      </p>
      <!-- 配置-查看 -->
      <div v-show="viewTable" class="contentWrap" style="padding:10px 20px 20px;">
        <!-- <p class="contentTitle">功能配置
          <el-button type="primary" style="vertical-align: top;margin-top: 7px;float: right;" @click="viewTable=!viewTable;editTable=!editTable">编辑</el-button>
        </p> -->
        <div style="padding:0 20px;">
          <p style="line-height: 20px;font-weight: 500;font-size: 16px;margin-top: 10px;">逆变功能配置</p>
          <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #e6e9ed;font-size:14px;margin-top: 5px;">
            <thead>
              <!-- <tr>
              <th colspan="3">逆变功能配置</th>
            </tr> -->
              <tr>
                <th style="width:40%">选项</th>
                <th style="width:30%">数值</th>
                <th style="width:30%">备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in inverterTableData">
                <td>{{ item.name }}</td>
                <td style="text-align: center;">{{ item.value }}</td>
                <td style="text-align: center;">{{ item.remark }}</td>
              </tr>
            </tbody>
          </table>
          <p style="line-height: 25px;font-weight: 500;font-size: 16px;margin-top: 10px;">充电功能配置</p>
          <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #e6e9ed;font-size:14px;">
            <thead>
              <!-- <tr>
              <th colspan="3">充电功能配置</th>
            </tr> -->
              <tr>
                <th style="width:40%">选项</th>
                <th style="width:30%">数值</th>
                <th style="width:30%">备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in chargingTableData">
                <td>{{ item.name }}</td>
                <td style="text-align: center;">{{ item.value }}</td>
                <td style="text-align: center;">{{ item.remark }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- 配置-编辑 -->
      <div v-show="editTable" class="contentWrap" style="padding:0 20px 20px;">
        <!-- <p class="contentTitle">功能配置
          <el-button type="primary" style="vertical-align: top;margin-top: 7px;float: right;" @click="editTable=false">取消</el-button>
        </p> -->
        <div style="padding:0 20px;">
          <p style="line-height: 20px;font-weight: 500;font-size: 16px;margin-top: 10px;">逆变功能配置</p>
          <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #e6e9ed;font-size:14px;margin-top: 5px;">
            <thead>
              <!-- <tr>
              <th colspan="3">逆变功能配置</th>
            </tr> -->
              <tr>
                <th style="width:40%">选项</th>
                <th style="width:30%">数值</th>
                <th style="width:30%">备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in inverterTableData" :key="index">
                <td>{{ item.name }}</td>
                <td style="text-align: center;">
                  <el-select v-if="item.type=='select'&&index===0" v-model="inverterTableEdit.batteryType" class="editTableTd" placeholder="请选择">
                    <el-option v-for="option in batteryTypeOptions" :key="option.value" :label="option.label" :value="option.value" />
                  </el-select>

                  <el-input v-if="item.type=='input'&&index===1" v-model="inverterTableEdit.lowVolRe" class="editTableTd" placeholder="请输入内容" />
                  <el-input v-if="item.type=='input'&&index===2" v-model="inverterTableEdit.lowVolAl" class="editTableTd" placeholder="请输入内容" />
                  <el-input v-if="item.type=='input'&&index===3" v-model="inverterTableEdit.lowVolPro" class="editTableTd" placeholder="请输入内容" />

                  <p v-if="item.type=='p'&&index===4">{{ item.value }}</p>

                  <el-select v-if="item.type=='select'&&index===5" v-model="inverterTableEdit.inverterStatus" class="editTableTd" placeholder="请选择">
                    <el-option v-for="option in inverterStatusOptions" :key="option.value" :label="option.label" :value="option.value" />
                  </el-select>

                  <el-radio v-if="item.type=='radio'&&index===6" v-model="inverterTableEdit.buzzerStatus" label="1">ON</el-radio>
                  <el-radio v-if="item.type=='radio'&&index===6" v-model="inverterTableEdit.buzzerStatus" label="2">OFF</el-radio>

                  <el-radio v-if="item.type=='radio'&&index===7" v-model="inverterTableEdit.loadSensing" label="1">15W</el-radio>
                  <el-radio v-if="item.type=='radio'&&index===7" v-model="inverterTableEdit.loadSensing" label="2">25W</el-radio>
                  <el-radio v-if="item.type=='radio'&&index===7" v-model="inverterTableEdit.loadSensing" label="3">OFF</el-radio>
                <!-- <button @click="myItem(inverterTableData)">anniu</button> -->
                </td>
                <td style="text-align: center;">{{ item.remark }}</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-button type="primary" style="vertical-align: top;margin-right: 20px;float: right;" @click="tableSubmit('inverter')">提交</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          <p style="line-height: 25px;font-weight: 500;font-size: 16px;margin-top: 10px;">充电功能配置</p>
          <table border="1" style="border-collapse:collapse;width:100%;border: 1px solid #e6e9ed;font-size:14px;">
            <thead>
              <!-- <tr>
              <th colspan="3">充电功能配置</th>
            </tr> -->
              <tr>
                <th style="width:40%">选项</th>
                <th style="width:30%">数值</th>
                <th style="width:30%">备注</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in chargingTableData" v-show="inverterTrShow||index===0" :key="index">
                <td>{{ item.name }}</td>
                <td style="text-align: center;">
                  <el-radio v-if="item.type=='radio'&&index===0" v-model="chargingTableEdit.chargerOnOff" label="1">ON</el-radio>
                  <el-radio v-if="item.type=='radio'&&index===0" v-model="chargingTableEdit.chargerOnOff" label="2">OFF</el-radio>

                  <el-input v-if="item.type=='input'&&index===1" v-model="chargingTableEdit.chargerVolABS" class="editTableTd" placeholder="请输入内容" />
                  <el-input v-if="item.type=='input'&&index===2" v-model="chargingTableEdit.chargerVolFloat" class="editTableTd" placeholder="请输入内容" />

                  <el-select v-if="item.type=='select'&&index===3" v-model="chargingTableEdit.chargerCurrent" class="editTableTd" placeholder="请选择">
                    <el-option v-for="option in chargerCurrentOptions" :key="option.value" :label="option.label" :value="option.value" />
                  </el-select>

                  <el-select v-if="item.type=='select'&&index===4" v-model="chargingTableEdit.chargerCurrentFloat" class="editTableTd" placeholder="请选择">
                    <el-option v-for="option in chargerCurrentFloatOptions" :key="option.value" :label="option.label" :value="option.value" />
                  </el-select>

                  <el-input v-if="item.type=='input'&&index===5" v-model="chargingTableEdit.rechargeVol" class="editTableTd" placeholder="请输入内容" />

                  <el-radio v-if="item.type=='radio'&&index===6" v-model="chargingTableEdit.temMon" label="1">Low Temperature</el-radio>
                  <el-radio v-if="item.type=='radio'&&index===6" v-model="chargingTableEdit.temMon" label="2">Normal Temperature</el-radio>
                  <el-radio v-if="item.type=='radio'&&index===6" v-model="chargingTableEdit.temMon" label="3">High Temperature</el-radio>

                  <el-radio v-if="item.type=='radio'&&index===7" v-model="chargingTableEdit.currentLimit" label="1">20A</el-radio>
                  <el-radio v-if="item.type=='radio'&&index===7" v-model="chargingTableEdit.currentLimit" label="2">30A</el-radio>
                  <el-radio v-if="item.type=='radio'&&index===7" v-model="chargingTableEdit.currentLimit" label="3">15A</el-radio>

                </td>
                <td style="text-align: center;">{{ item.remark }}</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-button type="primary" style="vertical-align: top;margin-right: 20px;float: right;" @click="tableSubmit('charging')">提交</el-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- 图片：充电、逆电器、锂电池 -->
      <div class="statuPictureWrap">
        <div class="statuPictureDiv">
          <img v-show="!isOn" class="statuPictureImg" src="@/assets/images/fan_gray.png" style="height: 105px;"><br>
          <img v-show="isOn&&isCharging" class="statuPictureImg" src="@/assets/images/jack.png" style="height: 105px;"><br>
          <img v-show="isOn&&!isCharging" class="statuPictureImg" src="@/assets/images/fan.png"><br>
          <p class="statuPictureP">
            <img v-show="isOn" class="statuPictureIcon" src="@/assets/images/vs_black.png">
            <img v-show="!isOn" class="statuPictureIcon" src="@/assets/images/vs_gray.png">
            <span class="statuPictureSpan">{{ voltage1 }}</span>
          </p>
        </div>
        <div class="statuPictureDiv">
          <img v-show="isOn&&isCharging" class="statuPictureImg" src="@/assets/images/arrow_green.png"><br>
          <img v-show="isOn&&!isCharging" class="statuPictureImg" src="@/assets/images/arrow_blue.png"><br>
          <p v-show="isOn&&!isCharging" class="statuPictureP" style="top: calc(50% + 30px);">
            <img class="statuPictureIcon" src="@/assets/images/as_black.png">
            <span class="statuPictureSpan">{{ capacity1 }}</span>
          </p>
        </div>
        <div class="statuPictureDiv">
          <img v-show="isOn" class="statuPictureImg" src="@/assets/images/inverter.png" style="height: 110px;"><br>
          <img v-show="!isOn" class="statuPictureImg" src="@/assets/images/inverter_gray.png" style="height: 110px;"><br>
          <img v-show="isOn" src="@/assets/images/tem_black.png" style="height: 40px;position: absolute;top: -53px;left: 85%;">
          <img v-show="!isOn" src="@/assets/images/tem.png" style="height: 40px;position: absolute;top: -53px;left: 85%;">
          <span style="position: absolute;top: -42px;left: calc(85% + 20px);width: 50px;">{{ temperature }}</span>
          <p v-show="!isOn" class="statuPictureP">
            <span class="statuPictureSpan" style="display: block;line-height: 20px;">OFFLINE</span>
          </p>
          <p v-show="isOn&&isCharging" class="statuPictureP">
            <span class="statuPictureSpan" style="display: block;line-height: 20px;">CHARGING</span>
          </p>
          <p v-show="isOn&&!isCharging" class="statuPictureP">
            <span class="statuPictureSpan" style="display: block;line-height: 20px;">DISCHARGING</span>
            <!-- <span class="statuPictureSpan" style="display: block;line-height: 20px;">OFFLINE</span> -->
          </p>
        </div>
        <div class="statuPictureDiv">
          <img v-show="isOn&&isCharging" class="statuPictureImg" src="@/assets/images/arrow_green.png"><br>
          <img v-show="isOn&&!isCharging" class="statuPictureImg" src="@/assets/images/arrow_blue.png"><br>
          <p class="statuPictureP" style="top: calc(50% + 30px);">
            <img v-show="isOn" class="statuPictureIcon" src="@/assets/images/a_black.png">
            <!-- <img v-show="isOn&&!isCharging" class="statuPictureIcon" src="@/assets/images/as_black.png"> -->
            <span v-show="isOn" class="statuPictureSpan">{{ capacity2 }}</span>
          </p>
        </div>
        <div class="statuPictureDiv">
          <img v-show="isOn" class="statuPictureImg" src="@/assets/images/cell.png" style="height: 100px;"><br>
          <img v-show="!isOn" class="statuPictureImg" src="@/assets/images/cell_gray.png" style="height: 100px;"><br>
          <p class="statuPictureP">
            <img v-show="isOn" class="statuPictureIcon" src="@/assets/images/v_black.png">
            <img v-show="!isOn" class="statuPictureIcon" src="@/assets/images/v_gray.png">
            <span class="statuPictureSpan">{{ voltage2 }}</span>
          </p>
        </div>
      </div>
    </div>

    <!-- WARNING -->
    <div class="contentWrap" style="padding-bottom: 0;">
      <p class="contentTitle">{{ $t('basicinfo.warning') }}</p>
      <div style="overflow-y: auto;">
        <div class="warningWrap">
          <div v-for="(item,index) in warningListFirst" :key="index" class="warningDivs">
            <!-- <div style="width:90px;height:90px;display: inline-block;" :title="item.isColor" :style="{background:item.imgUrl}" /> -->
            <img style="width:90px;height:90px;display: inline-block;" :title="item.isColor" :src="item.imgUrl">
            <p style="margin-top: 5px;">{{ item.name }}</p>
          </div>
        </div>
        <div class="warningWrap">
          <div v-for="(item,index) in warningListSecond" :key="index" class="warningDivs">
            <!-- <div style="width:90px;height:90px;display: inline-block;" :title="item.isColor" :style="{background:item.imgUrl}" /> -->
            <img style="width:90px;height:90px;display: inline-block;" :title="item.isColor" :src="item.imgUrl">
            <p style="margin-top: 5px;">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { findDeviceInfo, getGNSSLastByMcuID, getIvtCfg, setIvtCfg } from '@/api/inverter'
import deviceListMapTem from '@/components/deviceListMapTem'// 高德和谷歌地图
import { updateTime, getDateAndHour } from '@/utils/updateTime.js'

import mqtt from 'mqtt'
import yhubproto from '@/proto/yhubproto'
import protobuf from 'protobufjs'
import { MQTT_SERVICE, MQTT_USERNAME, MQTT_PASSWORD } from '@/utils/sysconstant.js'

const YhubRequest = yhubproto.lookup('framework.YhubRequest')
var options = {}
client = mqtt.connect(MQTT_SERVICE, options)
var client
export default {
  components: {
    deviceListMapTem // 地图
  },
  data() {
    this.yhubproto
    this.protobuf
    return {
      // 地图----start
      height: '260px',
      value1: false,
      locationList: [],
      isShowMapFloat: false, // 是否显示图示
      // 地图----end

      flashcodeV: '--',
      loadV: '--',
      heightV: '--',
      E2X: '--',
      E2Y: '--',
      deviceID: '',
      basicinfo: {
        batteryCapacity: '--',
        batteryVoltage: '--'
      },
      statuList: {
        current: '--',
        voltageRaw: '--',
        batteryTemperature: '--',
        soc: '--'
      },
      timeAgo: '',
      timeAgoPGT: '',
      timeAgoStatus: '',
      timeAgoStatusRET: '',
      inverterData: null,
      isCharging: false,
      isOn: false,
      msg: null,
      voltage1: '--',
      capacity1: '--',
      temperature: '--',
      voltage2: '--',
      capacity2: '--',
      location: {},
      viewTable: false,
      editTable: false,
      warningListFirst: [{ name: 'E1', isColor: 'false', imgUrl: require('@/assets/images/E1_gray.png') },
        { name: 'E2', isColor: 'false', imgUrl: require('@/assets/images/E2_gray.png') },
        { name: 'E3', isColor: 'false', imgUrl: require('@/assets/images/E3_gray.png') },
        { name: 'E4', isColor: 'false', imgUrl: require('@/assets/images/E4_gray.png') },
        { name: 'E5', isColor: 'false', imgUrl: require('@/assets/images/E5_gray.png') },
        { name: 'E6', isColor: 'false', imgUrl: require('@/assets/images/E6_gray.png') },
        { name: 'E7', isColor: 'false', imgUrl: require('@/assets/images/E7_gray.png') }],
      warningListSecond: [{ name: 'E10', isColor: 'false', imgUrl: require('@/assets/images/E10_gray.png') },
        { name: 'E11', isColor: 'false', imgUrl: require('@/assets/images/E11_gray.png') },
        { name: 'E12', isColor: 'false', imgUrl: require('@/assets/images/E12_gray.png') },
        { name: 'E13', isColor: 'false', imgUrl: require('@/assets/images/E13_gray.png') },
        { name: 'E14', isColor: 'false', imgUrl: require('@/assets/images/E14_gray.png') },
        { name: 'E15', isColor: 'false', imgUrl: require('@/assets/images/E15_gray.png') },
        { name: 'E16', isColor: 'false', imgUrl: require('@/assets/images/E16_gray.png') }],
      oldErrCode: null,
      inverterTableData: [{ name: 'Battery Type Setting', value: '--', remark: '', type: 'select' },
        { name: 'Battery Low Voltage Recovery Setting', value: '--', remark: '	11.5v ~13.0v', type: 'input' },
        { name: 'Battery Low Voltage Alarm Setting', value: '--', remark: '	11.0v-12.5v', type: 'input' },
        { name: 'Battery Low Voltage Protection Setting', value: '--', remark: '	10.5v- 12.0v ', type: 'input' },
        { name: 'Battery Over Voltage Protection Set Point', value: '--', remark: '', type: 'p' },
        { name: 'Inverter Status Setting', value: '--', remark: '', type: 'select' },
        { name: 'Buzzer Status Setting', value: '--', remark: '', type: 'radio' },
        { name: 'Load Sensing Low Power Mode Setting', value: '--', remark: '', type: 'radio' }],

      chargingTableData: [{ name: 'Battery Charger On / Off Setting', value: '--', remark: '', type: 'radio' },
        { name: 'Battery Charging Voltage During ABS Stage', value: '--', remark: '	 13.8v--14.8v  ', type: 'input' },
        { name: 'Battery Charging Voltage During Float Stage', value: '--', remark: ' 13.0v--14.0v ', type: 'input' },
        { name: 'Battery Charging Current Setting', value: '--', remark: '', type: 'select' },
        { name: 'Battery Charging Current During Float Stage', value: '--', remark: '', type: 'select' },
        { name: 'Battery Recharge Voltage', value: '--', remark: '	 12.8v-- 14.0v', type: 'input' },
        { name: 'Battery Temperature Monitoring Display', value: '--', remark: '', type: 'radio' },
        { name: 'AC Current Input Limit', value: '--', remark: '', type: 'radio' }],
      inverterTableEdit: {},
      batteryTypeOptions: [{ label: 'GEL', value: '1' },
        { label: 'AGM', value: '2' },
        { label: 'FLOODE', value: '3' },
        { label: 'LITHIUM', value: '4' },
        { label: 'PROGRAM', value: '5' },
        { label: 'PSY', value: '6' }],
      inverterStatusOptions: [{ label: 'ON', value: '1' },
        { label: 'ABU', value: '2' },
        { label: 'MBU', value: '3' },
        { label: 'OFF', value: '4' }],
      chargingTableEdit: {},
      inverterTrShow: true,
      chargerCurrentOptions: [{ label: '80A', value: '1' },
        { label: '60A', value: '2' },
        { label: '40A', value: '3' },
        { label: '25A', value: '4' },
        { label: '100A', value: '5' }],
      chargerCurrentFloatOptions: [{ label: '15A', value: '1' },
        { label: '10A', value: '2' },
        { label: '5A', value: '3' },
        { label: '2A', value: '4' },
        { label: '20A', value: '5' }],
      mGetInverterCfgData: {}

    }
  },
  watch: {
    chargingTableEdit: {
      handler: function(newVal, oldVal) {
        if (newVal.chargerOnOff === '2') { this.inverterTrShow = false } else { this.inverterTrShow = true }
      },
      deep: true
    },
    inverterTableData: {
      handler: function(newVal, oldVal) {
        this.inverterTrShow = newVal
      },
      deep: true
    },
    chargingTableData: {
      handler: function(newVal, oldVal) {
        this.chargingTableData = newVal
      },
      deep: true
    }
  },
  mounted() {
    console.log(this.$store)
    if (this.$store.state.map == 'gdMap') { this.value1 = true } else { this.value1 = false }

    this.mcuId = this.$route.query.mcuId
    this.deviceID = 'WEB2_' + this.mcuId + '_' + this.getuuid()
    options = {
      connectTimeout: 40000,
      clientId: this.deviceID,
      username: MQTT_USERNAME,
      password: MQTT_PASSWORD,
      clean: true
    }
    this.queryList()
    this.getIvtCfg()
    this.$nextTick(() => {
      this.mqttMSG()
    })
  },
  created() {
    this.setTimer()
  },
  destroyed: function() {
    clearInterval(this.timer)
    this.timer = null
    this.setTimer()
  },
  methods: {
    // 获取地址信息--高德地图
    getPosition({ address, lat, lng, name }) {
      this.postForm.detailedAddress = address
      this.postForm.longitude = String(lng)
      this.postForm.latitude = String(lat)
    },
    fullScreen(height) {
      this.height = height
    },
    // 查询
    queryList() {
      var param = {
        'mcuId': this.$route.query.mcuId,
        myToken: this.$store.state.token
      }
      findDeviceInfo(param).then(response => {
        this.basicinfo = response.resultModel
        // this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity + 'Ah'
        // this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage + 'V'

        if (this.basicinfo.batteryCapacity) this.basicinfo.batteryCapacity = this.basicinfo.batteryCapacity > 1000 ? (this.basicinfo.batteryCapacity / 100 + 'Ah') : (this.basicinfo.batteryCapacity + 'Ah')
        else { this.basicinfo.batteryCapacity = '--' }
        if (this.basicinfo.batteryVoltage) this.basicinfo.batteryVoltage = this.basicinfo.batteryVoltage > 100 ? (this.basicinfo.batteryVoltage / 100 + 'V') : (this.basicinfo.batteryVoltage + 'V')
        else { this.basicinfo.batteryVoltage = '--' }
      })

      getGNSSLastByMcuID(param).then(res => {
        if (res.resultCode !== 1001 || res.resultModel == null) {
          return
        }
        this.locationList = []
        var locatin = {}
        locatin.davaceName = this.basicinfo.deviceName
        locatin.mcuId = this.$route.query.mcuId
        locatin.lType = res.resultModel.lType
        this.location.lat = locatin.lat = res.resultModel.lat
        this.location.lon = locatin.lon = res.resultModel.lon
        locatin.updataTime = res.resultModel.updataTime
        this.location.latestUpdate = getDateAndHour(new Date().getTime(), 'noSecond')
        this.locationList.push(locatin)
        // debugger
        // this.gMap.setMakers()
        this.$refs.maps.setMakers(this.locationList)
        var center = {
          lat: res.resultModel.lat,
          lon: res.resultModel.lon,
          radius: '100'
        }
        // this.$refs.maps.setCenter(center)
      })
    },
    getIvtCfg() {
      var param = {
        'mcuId': this.$route.query.mcuId
      }
      getIvtCfg(param).then(res => {
      })
    },
    mqttMSG() {
      // mqtt连接
      client.on('connect', (e) => {
        console.log('连接成功`````````````:')
        client.subscribe('gpd/#', { qos: 1 }, (error) => {
          if (!error) {
            console.log('订阅成功')
          } else {
            console.log('订阅失败')
          }
        })
      })
      // 接收消息处理
      client.on('message', (topic, message) => {
        // 判断response是否是arrayBuffer
        if (!topic.match(this.mcuId)) { return }

        this.topic = topic
        var yhubRequest
        try {
          const buf = protobuf.util.newBuffer(message)
          var newBuffer = buf.slice(0, buf.length - 2)
          yhubRequest = YhubRequest.decode(newBuffer)
        } catch (err) {
          this.msg = err.toString()
          return err
        }
        console.log('收到数据==>' + JSON.stringify(yhubRequest))
        if (yhubRequest) {
          if (yhubRequest.payload === 'mCan') {
            this.inverterData = yhubRequest.mCan.mInverterData // 实时详情、警告
            // console.log('this.inverterData---', this.inverterData)
            if (this.inverterData) {
              if (this.inverterData.connection === 1) { // 设备状态 1：连接 2：断开
                this.isOn = true
              } else {
                this.isOn = false
              }
              if (this.inverterData.chargeCur && this.inverterData.chargeCur > 0) { // 充电
                this.isCharging = true
                this.voltage1 = this.inverterData.acvol / 100 + ' V'
                // this.capacity1 = this.inverterData.acvol/100+' A'
                if (this.inverterData.inverterTemperature) this.temperature = this.inverterData.inverterTemperature > 1000 ? (Math.round(this.inverterData.inverterTemperature / 100) + ' ℃') : (this.inverterData.inverterTemperature + ' ℃')
                this.voltage2 = this.inverterData.chargeVol / 100 + ' V'
                this.capacity2 = this.inverterData.chargeCur / 100 + ' A'
              } else { // 放电
                this.voltage1 = this.inverterData.inverterOutVol / 100 + ' V'
                this.capacity1 = this.inverterData.inverterOutCur / 100 + ' A'
                if (this.inverterData.inverterTemperature) this.temperature = this.inverterData.inverterTemperature > 1000 ? (Math.round(this.inverterData.inverterTemperature / 100) + ' ℃') : (this.inverterData.inverterTemperature + ' ℃')
                // this.temperature = this.inverterData.inverterTemperature + ' ℃'
                this.voltage2 = this.inverterData.batVoltage / 100 + ' V'
                this.capacity2 = this.inverterData.batCurrent / 100 + ' A'
              }
              // 警告--------------------------------------------------start
              // 将亮了的图片还原成灰色
              if (this.oldErrCode && this.oldErrCode <= 7) {
                this.warningListFirst[this.oldErrCode - 1].imgUrl = require('@/assets/images/E' + this.oldErrCode + '_gray.png')
              } else if (this.oldErrCode <= 16 && this.oldErrCode >= 10) {
                this.warningListSecond[this.oldErrCode - 10].imgUrl = require('@/assets/images/E' + this.oldErrCode + '_gray.png')
              }
              var errcode = this.inverterData.errorCode
              this.oldErrCode = errcode
              if (errcode && errcode <= 7) {
                // this.warningListFirst[errcode - 1].imgUrl = require('@/assets/images/E1.png')
                this.warningListFirst[errcode - 1].imgUrl = require('@/assets/images/E' + errcode + '.png')
              } else if (errcode <= 16 && errcode >= 10) {
                this.warningListSecond[errcode - 10].imgUrl = require('@/assets/images/E' + errcode + '.png')
              }
              // 警告--------------------------------------------------end
              // console.log(this.inverterData)
            }
            if (yhubRequest.mCan.mGetInverterCfgData && yhubRequest.mCan.mGetInverterCfgData.cfgData) { // 配置信息
              this.mGetInverterCfgData = yhubRequest.mCan.mGetInverterCfgData.cfgData // 配置信息
              console.log(yhubRequest.mCan.mGetInverterCfgData.cfgData)

              console.log('收到mGetInverterCfgData数据==>', this.mGetInverterCfgData)
              // 逆电器配置
              this.batteryTypeOptions.forEach((v, i) => {
                if (v.value == this.mGetInverterCfgData.batType) this.inverterTableData[0].value = this.batteryTypeOptions[i].label
              })
              // this.inverterTableData[1].value = this.batteryTypeOptions[i].label
              this.inverterTableData[1].value = this.mGetInverterCfgData.rechargeVol / 100
              this.inverterTableData[2].value = this.mGetInverterCfgData.batLowVolAlarm / 100
              this.inverterTableData[3].value = this.mGetInverterCfgData.batLowVolProtect / 100
              this.inverterTableData[4].value = this.mGetInverterCfgData.batOverVolProtect / 100
              this.inverterStatusOptions.forEach((v, i) => {
                if (v.value == this.mGetInverterCfgData.inverterStatus) this.inverterTableData[5].value = this.inverterStatusOptions[i].label
              })
              switch (this.mGetInverterCfgData.buzzerStatus) {
                case 1:this.inverterTableData[6].value = 'ON'; break
                case 2:this.inverterTableData[6].value = 'OFF'; break
              }
              switch (this.mGetInverterCfgData.lowPowerMode) {
                case 1:this.inverterTableData[7].value = '10W'; break
                case 2:this.inverterTableData[7].value = '15W'; break
                case 3:this.inverterTableData[7].value = '20W'; break
                case 4:this.inverterTableData[7].value = '25W'; break
                case 5:this.inverterTableData[7].value = 'OFF'; break
              }
              console.log(this.inverterTableData)

              // 充电器配置
              switch (this.mGetInverterCfgData.chargeKey) {
                case 1:this.chargingTableData[0].value = 'ON'; break
                case 2:this.chargingTableData[0].value = 'OFF'; break
              }
              this.chargingTableData[1].value = this.mGetInverterCfgData.vol_ABS / 100
              this.chargingTableData[2].value = this.mGetInverterCfgData.volFloat / 100
              this.chargerCurrentOptions.forEach((v, i) => {
                if (v.value == this.mGetInverterCfgData.chargeCurr) this.chargingTableData[3].value = this.chargerCurrentOptions[i].label
              })
              this.chargerCurrentFloatOptions.forEach((v, i) => {
                if (v.value == this.mGetInverterCfgData.curr_float) this.chargingTableData[4].value = this.chargerCurrentFloatOptions[i].label
              })
              switch (this.mGetInverterCfgData.bTM) {
                case 1:this.chargingTableData[5].value = 'Low Temperature'; break
                case 2:this.chargingTableData[5].value = 'Normal Temperature'; break
                case 3:this.chargingTableData[5].value = 'High Temperature'; break
              }
              switch (this.mGetInverterCfgData.cbr) {
                case 1:this.chargingTableData[6].value = '20A'; break
                case 2:this.chargingTableData[6].value = '30A'; break
                case 3:this.chargingTableData[6].value = '15A'; break
              }
              console.log(this.chargingTableData)
            }
          }
          if (yhubRequest.payload === 'mRealTimeData') { // STATUS/MAP
            if (!yhubRequest.mRealTimeData.dRecord) return
            this.statuList = yhubRequest.mRealTimeData.dRecord
            console.log(this.statuList)
            if (this.statuList && this.statuList.currentCharging && this.statuList.currentDischarging) {
              this.statuList.current = ((this.statuList.currentCharging - this.statuList.currentDischarging) / 100).toFixed(2) + 'A'
            }
            this.statuList.soc = Math.round(this.statuList.soc / 100) + '%'
            this.statuList.voltageRaw = this.statuList.voltageRaw / 100 + 'V'
            this.statuList.batteryTemperature = Math.round(this.statuList.batteryTemperature / 100) + '℃'
            if (this.$store.state.language == 'en') { this.timeAgoStatus = 'Just Now' } else { this.timeAgoStatus = '刚刚' }
            this.timeAgoStatusRET = new Date().getTime()
          }
        }
        // console.log('收到来自', topic, '的消息', yhubRequest)
        this.msg = yhubRequest
      })
      // 断开发起重连
      client.on('reconnect', (error) => {
        console.log('正在重连:', error)
      })
      // 链接异常处理
      client.on('error', (error) => {
        console.log('连接失败:', error)
      })
    },
    setTimer() {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (this.timeAgo) this.timeAgo = updateTime(this.timeAgoPGT, this.$store.state.language)
          if (this.timeAgoStatus) this.timeAgoStatus = updateTime(this.timeAgoStatusRET, this.$store.state.language)
        }, 60000)
      }
    },
    // uuid随机生成 MQTT
    getuuid() {
      var uid = []
      var hexDigits = '0123456789abcdefghijklmnopqrst'
      for (var i = 0; i < 32; i++) {
        uid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      uid[6] = '4'
      uid[15] = hexDigits.substr((uid[15] & 0x3) | 0x8, 1)
      var uuid = uid.join('')
      return uuid
    },
    getBit(n, k) { // MQTT
      var bx = false
      if (((n >> k) & 1) == 1) {
        bx = true
      } else {
        bx = false
      }
      return bx
    },
    clickSet() {
      this.viewTable = !this.viewTable
      if (this.editTable) {
        this.viewTable = false
        this.editTable = false
      }
      this.getIvtCfg()
    },
    tableSubmit() { // 配置--提交
      var param = {
        mcuId: this.$route.query.mcuId,
        myToken: this.$store.state.token,
        // 逆电器
        batType: this.inverterTableEdit.batteryType || 0, // 电池类型 1:GEL 2:AGM 3:FLOODE 4:Lithium 5:Program 6:PSY
        batLowVolRst: this.inverterTableEdit.lowVolRe || 0, // DC输入电池低压保护恢复电压值设置
        batLowVolAlarm: this.inverterTableEdit.lowVolAl || 0, // 电池低压警告值 100倍 DC输入电池低压报警电压值
	    	batLowVolProtect: this.inverterTableEdit.lowVolPro || 0, // 电池低压保护值 100倍 DC输入电池低压保护电压值
	    	inverterStatus: this.inverterTableEdit.inverterStatus || 0, // 逆变器状态设置1:ON,2:AbU,3:MbU,4:OFF
	    	buzzerStatus: this.inverterTableEdit.buzzerStatus || 0, // 蜂鸣器状态设置1:ON,2:OFF
	    	lowPowerMode: this.inverterTableEdit.loadSensing || 0, // 省电模式设置1:15W,2:25W,3:OFF
        // 充电器
        chargeKey: this.chargingTableEdit.chargerOnOff || 0, // 充电开关 NO:1  OFF:2
        vol_ABS: this.chargingTableEdit.chargerVolABS || 0, // ABS电压 100倍
        vol_float: this.chargingTableEdit.chargerVolFloat || 0, // 浮充电压 100倍
        chargeCurr: this.chargingTableEdit.chargerCurrent || 0, // 充电电流 80A:1  60A:2 40A:3 25A:4 100A:5
        curr_float: this.chargingTableEdit.chargerCurrentFloat || 0, // 浮充电流 15A:1 10A:2 5A:3 2A:4 20A:5
        rechargeVol: this.chargingTableEdit.rechargeVol || 0, // 重充电压 100倍 重新进入大电流充电电压值
        bTM: this.chargingTableEdit.temMon || 0, // 电池温度 1:    2:   3:
        cbr: this.chargingTableEdit.currentLimit || 0// 市电输入限流 20A:1  30A:2   15A:3
        // mode:'';//逆变器型号
      }
      console.log(param)
      setIvtCfg(param).then(res => {
        if (res.code == 200) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success',
            duration: 2000
          })
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0;
  padding:0;
}
.contentTitle{
  height:50px;
  line-height:50px;
  border-bottom: 2px solid #e6e9ed;
  font-weight: bold;
}
.headerP{
  width: calc(50% - 13px);
  display: inline-block;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #606266;
}
.headerP:nth-of-type(odd){  //奇数
  margin-left:20px;
}
.headerP:nth-child(n+4){
  border-top: 1px solid #e6e9ed;
}
.headerP span{
  padding-left:20px;
}
.headerP span:nth-of-type(odd){
  width:50%;
  display: inline-block;
}
.statuP{
  width: 100%;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid rgb(230, 233, 237);
  font-size: 14px;
  color: #606266;
}
.statuP span{
  padding-left:20px;
}
.statuP span:nth-of-type(odd){
  width:50%;
  display: inline-block;
}
.statuP:last-child{
  border-bottom: none;
}
.statuWrap{
  width:calc(50% - 13px);
  padding-bottom: 0;
  display:inline-block;
}
.mapFloatBox{
  position: absolute;
  width: 314px;
  // height: 137px;
  bottom: 0;
  right: 0;
  background: rgba(0,0,0,0.5);
  color: white;
  padding: 10px 20px;
}
.mapFloatBox p{
  font-size: 14px;
  line-height: 28px;
}
.mapFloatBox p.mapFloatBoxTitle{
  font-size: 16px;
  margin-bottom: 5px;
}
.timeAgo{
  font-size: 16px;
  color: #ff9933;
  margin-left: 10px;
}
.statuPictureWrap{
  height: 220px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  overflow-x: auto;
}
.statuPictureDiv{
  height: 76px;
  width: calc(20% - 4px);
  align-items: center;
  justify-content: center;
  display: flex;
  // border: 1px solid red;
  position: relative;
  min-width: 160px;
}
.statuPictureImg{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.statuPictureP{
  position: absolute;
  top: calc(50% + 70px);
  width: 100%;
  text-align: center;
}
.statuPictureIcon{
  height: 30px;
}
.statuPictureSpan{
  line-height: 30px;
  vertical-align: top;
}
// .realtimeDivs:last-child{
//   border-right:none;
// }
// .realtimeDivs p:nth-of-type(2){
//   font-size: 30px;
//   line-height: 48px;
// }
.warningWrap{
  // height:280px;
  padding:50px 0;
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  text-align: center;
  // overflow-y: auto;
}
.warningWrap:nth-of-type(2){
  padding-top:0;
}
.warningDivs{
  display: inline-block;
}
.companyP{
  height:50px;
  line-height: 50px;
  font-size: 14px;
  color: #606266;
  border-bottom: 1px solid #e6e9ed;
}
.companyP:last-child{
  border-bottom:none;
}
.companyP span{
  padding-left:20px;
}
.companyP span:nth-of-type(odd){
  width:30%;
  display: inline-block;
}
.editTableTd{
  width:70%;
}
</style>
